import { render, staticRenderFns } from "./geolocation-permission-settings.vue?vue&type=template&id=d8bc9150&scoped=true"
import script from "./geolocation-permission-settings.vue?vue&type=script&lang=js"
export * from "./geolocation-permission-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8bc9150",
  null
  
)

export default component.exports